@if (label) {
  <app-control-header
    [label]="label"
    [labelWithColon]="titleWithColon"
    [labelParamsObj]="labelParamsObj"
    [index]="index"
    [required]="required"
    [infoTooltip]="infoTooltip"
    [infoTooltipPlacement]="infoTooltipPlacement"
    [infoTooltipClass]="infoTooltipClass"
  ></app-control-header>
}

<div class="wrapper h-10">
  <mat-datepicker
    #picker
    mat-button
    [startAt]="hasValue ? undefined : startAt"
    [panelClass]="panelClass"
    [calendarHeaderComponent]="datePickerHeader"
    (closed)="onDatepickerClosed()"
  ></mat-datepicker>

  <button data-test-id="date-picker-btn" class="datepicker-btn" [disabled]="disabled" (click)="openDatepicker()">
    <input
      class="datepicker-input text-base"
      readonly
      [class.no-icon]="!hasIcon"
      [class.text-navy-70]="disabled"
      [matDatepicker]="picker"
      [min]="minDate"
      [max]="maxDate"
      [disabled]="disabled"
      [value]="value"
      (dateChange)="dateChange($event)"
      (click)="openDatepicker()"
    />

    @if (!value) {
      <span class="absolute text-navy-70 whitespace-nowrap font-main text-base w-min pl-2.5 pointer-events-none">
        {{ placeholder | translate }}
      </span>
    }

    @if (hasIcon) {
      <svg-icon
        class="datepicker-icon"
        preserveAspectRatio="none"
        [src]="svgIconPath ? svgIconPath : value ? 'calendar-approve' : 'calander'"
        [stretch]="true"
      ></svg-icon>
    }
  </button>
</div>

@if (dirty || !validateOnDirty) {
  <app-control-errors [errorTexts]="errorTexts"></app-control-errors>
}
